<template>
  <ui-collapse
    data-test="filter-and-sort-accommodation-categories"
    data-filter-categories-scroll-target
    :collapse-id="`collapse-filter-and-sort-accommodation-categories`"
    @collapse-open="scrollToCategories"
  >
    <template #ui-collapse-title>
      <translate>Accommodation categories</translate>
      <selected-categories
        :selected-ids="selectedCategoryIdsOrAll"
        class="filtered-categories"
      />
    </template>
    <template #ui-collapse-body>
      <categories-selector
        :category-ids="selectedCategoryIds"
        :category-facet-counts="categoryFacetCounts"
        :is-reactive-counts="true"
        :facets="searchWizardStore.wizardFilters.facets"
        class="accommodation-categories"
        @change-category-ids="changeCategoryIds"
        @subcategory-group-change="subcategoryGroupChange($event)"
      />
    </template>
  </ui-collapse>
</template>

<script lang="ts">
import CATEGORY_MAP from '~/json/catRoot.json'
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

@Component({
  setup() {
    const searchWizardStore = useSearchWizardStore(usePinia())
    return {
      searchWizardStore,
    }
  },
})
class FilterAndSortCategories extends Vue {
  searchWizardStore: ReturnType<typeof useSearchWizardStore>

  @Prop()
  selectedCategoryIds: string[]

  get selectedCategoryIdsOrAll(): string[] {
    if (this.selectedCategoryIds && this.selectedCategoryIds.length) {
      return this.selectedCategoryIds
    }
    return Object.keys(CATEGORY_MAP)
  }

  get categoryFacetCounts() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const counts = this.searchWizardStore.counts as any
    return {
      ...counts?.categoriesCounts,
      ...counts?.keywordsCounts,
    }
  }

  changeCategoryIds(categoryIds: string[]) {
    this.$emit('changeCategoryIds', categoryIds)
  }

  scrollToCategories() {
    this.$puScrollTo('[data-filter-categories-scroll-target]', {
      duration: 300,
      offset: 0,
    })
  }

  subcategoryGroupChange(event: { enabled: string[]; disabled: string[] }) {
    this.$emit('subcategoryGroupChange', event)
  }
}

export default toNative(FilterAndSortCategories)
</script>
<style scoped>
.filtered-categories {
  margin-right: 2em;
  margin-bottom: 0.5em;
}

.accommodation-categories {
  padding: 0 1em;
}

.accommodation-categories :deep(fieldset) {
  margin: 1em 0;
}

.accommodation-categories :deep(fieldset ~ fieldset) {
  margin: 1.5em 0 1em;
}

.accommodation-categories :deep(fieldset.desktop ~ fieldset) {
  margin: 2em 0;
}
</style>
